export default __webpack_public_path__ + "static/media/band4.23899d7b.jfif";